import React, { Component } from 'react';
import { markdownToHtml } from '$lib/markdown';
import { Input } from 'antd';
import styles from './styles.scss';
import PassageSource from '../../PassageSource';

const AUTOSAVE_INTERVAL = 30 * 1000;

class EssayWriting extends Component {
  componentDidMount() {
    const { handleEssaySave } = this.props;
    this.autoSaveInterval = setInterval(() => {
      handleEssaySave();
    }, AUTOSAVE_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.autoSaveInterval);
  }

  handleOnChange = (e) => {
    const response = e.target.value;
    this.props.handleEssayOnChange({ response });
  };

  render() {
    const { quizState } = this.props;
    const { essayPrompt, essayResponse } = quizState;

    const { text, prompt, source } = essayPrompt;
    const { response, submitAt } = essayResponse;
    const disabled = !!submitAt;

    return (
      <div className={styles.layout}>
        <div data-aaa="essayPrompt" className={styles.promptSection}>
          {markdownToHtml(text)}
          <div className={styles.instructionsPrompt}>{prompt}</div>
          <PassageSource className={styles.source} passageSource={source} />
        </div>
        <div className={styles.writingSection}>
          <div className={styles.writingSectionPrompt}>Write your response below</div>
          <Input.TextArea
            data-aaa="essayInput"
            disabled={disabled}
            onChange={this.handleOnChange}
            defaultValue={response}
            className={styles.writingInput}
          />
        </div>
      </div>
    );
  }
}

export default EssayWriting;
